import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MultiLanguageModule } from '@/app/multi-language.module';
import { LiveConnectionStatusService } from './live-connection-status.service';

/** Subtiel navbar-icoontje zolang de live verbinding langer dan 30 s weg is. */
@Component({
  selector: 'egi-live-connection-indicator',
  imports: [MultiLanguageModule],
  template: `
    @if (status.connectionLost()) {
      <span
        class="live-connection-lost"
        role="status"
        data-test-id="live-connection-lost"
        [title]="'platform.liveConnection.lostTooltip' | transloco"
        [attr.aria-label]="'platform.liveConnection.lostTooltip' | transloco"
      >
        <i class="fas fa-link-slash" aria-hidden="true"></i>
      </span>
    }
  `,
  styleUrl: './live-connection-indicator.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LiveConnectionIndicatorComponent {
  protected readonly status = inject(LiveConnectionStatusService);
}
